import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[nbcDisableRightClick]' // Custom selector to use in HTML
    ,
    standalone: false
})
export class NbcDisableRightClickDirective {

  @HostListener('contextmenu', ['$event']) // Listen to right-click event
  onRightClick(event: MouseEvent): void {
    event.preventDefault(); // Prevent the context menu
  }

}